import {
    REQUEST_AUTOCOMPLETE,
    storeAutocompleteResults,
    reportAutocompleteError,
    toggleAutocompleteLoading,
    clearAutocompleteError,
} from 'app/store/actions';
import { departureCitySelector } from 'app/store/selectors';
import { requestAutocomplete } from 'app/store/sagas/effects/requestAutocomplete';
import { takeLatest, select, put } from 'redux-saga/effects';
import { isSpaceOnlyOrEmptyString } from 'app/functions';
import { ERROR_AUTOCOMPLETE } from 'app/models/Error';

function* onRequestAutocomplete(action) {
    if (isSpaceOnlyOrEmptyString(action.query)) {
        return;
    }

    const departureCity = action.sendDepartureCityId ? yield select(departureCitySelector) : null;

    yield put(clearAutocompleteError(action.direction));
    yield put(toggleAutocompleteLoading(action.direction, true));

    try {
        const results = yield requestAutocomplete({
            query: action.query,
            departureCity: departureCity && departureCity.legacyId ? departureCity.id : null,
            direction: action.direction,
        });

        yield put(storeAutocompleteResults(results, action.direction, action.key));
    } catch (err) {
        yield put(reportAutocompleteError(ERROR_AUTOCOMPLETE, 'Failed to fetch results.', action.direction));
    }

    yield put(toggleAutocompleteLoading(action.direction, false));
}

export function* requestAutocompleteWatcher() {
    yield takeLatest(REQUEST_AUTOCOMPLETE, onRequestAutocomplete);
}
